import React from 'react';
import PropTypes from 'prop-types';
import Input from '@ferris/react/components/forms/Input';

function LocationField(props) {
    const {
        fieldLabelKey,
        fieldLabelTranslation,
        value,
        onChangeHandler,
        errorMessage,
        onBlur,
        hide,
        classes
    } = props;
    if (hide) return null;
    return (
        <Input
            formControlProps={
                { id: fieldLabelKey }
            }
            name={fieldLabelKey}
            fullWidth
            label={fieldLabelTranslation}
            type="text"
            isControlled
            floatLabel
            value={value}
            onChange={onChangeHandler}
            invalid={errorMessage && errorMessage.length}
            validationMessage={errorMessage || ''}
            onBlur={onBlur}
            aria-label={fieldLabelTranslation}
            aria-invalid={!!errorMessage}
            classes={classes}
            data-glance-masked="true"
        />
    );
}

LocationField.propTypes = {
    fieldLabelKey: PropTypes.string.isRequired,
    fieldLabelTranslation: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    errorMessage: PropTypes.string.isRequired,
    classes: PropTypes.string.isRequired,
    hide: PropTypes.bool
};

LocationField.defaultProps = {
    hide: false
};

export default LocationField;
